<script setup lang="ts">
import { ref } from 'vue'
import { formatDate } from '../../../../utilities/helpers'
import BaseButtonDanger from '../../../base/BaseButtonDanger.vue'
import { TrashIcon } from '@heroicons/vue/outline'
import LoadingSpinner from '../../../base/LoadingSpinner.vue'
import { i18n } from '../../../../localization'
import { notifyError, notifySuccess } from '../../../../utilities/useNotifications'
import { KeycloakCredential, useKeycloakState } from '../../../../utilities/account/useKeycloakState'

const state = useKeycloakState()

defineProps<{
    credential: KeycloakCredential
}>()

const loading = ref(false)

function deleteCredential(credential) {
    loading.value = true
    state
        .deleteCredential(credential.id)
        .then(() => {
            notifySuccess(i18n.global.t('security.two_factor_authentication.remove_success'))
            state.fetchCredentials()
            loading.value = false
        })
        .catch((e) => {
            loading.value = false
            notifyError(e.response?.data?.message || i18n.global.t('errors.general_error'))
        })
}
</script>

<template>
    <tr>
        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
            {{ $t(`security.two_factor_authentication.types.${credential.type}`) }}
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            {{ credential.userLabel }}
        </td>
        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            {{ formatDate(new Date(credential.createdDate)) }}
        </td>
        <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
            <BaseButtonDanger
                v-if="credential.removeable"
                size="sm"
                :disabled="loading"
                @click="deleteCredential(credential)">
                <span>
                    <LoadingSpinner v-show="loading" class="-ml-1 mr-2 h-4 w-4 fill-primary" />
                    <TrashIcon v-show="!loading" class="-ml-1 mr-2 h-4 w-4" />
                </span>
                {{ $t('security.two_factor_authentication.remove') }}
            </BaseButtonDanger>
            <span v-else class="font-semibold text-gray-500">
                {{ $t('security.two_factor_authentication.non_removeable') }}
            </span>
        </td>
    </tr>
</template>
